import { toggleIdInList } from "./idListToggle";

// GATE-01-A (agent-logs/runs/2026-09-11-spec-219-offers/evidence/
// human-resolution-gate-01-dup-and-format.json): el sufijo común de
// `buildInput` (lugares de consumo + vigencia + estado) era el mismo código
// palabra por palabra en benefits/BenefitsScreen.tsx y
// rewards/RewardsScreen.tsx. Pura transformación de datos — extracción sin
// cambio de comportamiento: mismos campos opcionales, mismo orden relativo.
export function placesAndValidityInput(values: {
  merchantIds: string[];
  workshopIds: string[];
  validFrom: string;
  validUntil: string;
  active: boolean;
}): {
  merchantIds: string[];
  workshopIds: string[];
  validFrom?: string;
  validUntil?: string;
  active: boolean;
} {
  return {
    merchantIds: values.merchantIds,
    workshopIds: values.workshopIds,
    ...(values.validFrom ? { validFrom: values.validFrom } : {}),
    ...(values.validUntil ? { validUntil: values.validUntil } : {}),
    active: values.active,
  };
}

// El par `toggleMerchant`/`toggleWorkshop` (alternar un id en la lista vía
// `toggleIdInList` y marcar el campo sucio) era el mismo código palabra por
// palabra en `BenefitEditor` y `RewardEditor`. Cada pantalla sigue llamando
// a su propio `setValue` tipado contra su propio `FormValues`, igual que
// `useIncludesField`.
export function usePlacesToggle(
  merchantIds: string[],
  workshopIds: string[],
  onMerchantIdsChange: (next: string[]) => void,
  onWorkshopIdsChange: (next: string[]) => void,
) {
  const toggleMerchant = (id: string) => {
    onMerchantIdsChange(toggleIdInList(merchantIds, id));
  };
  const toggleWorkshop = (id: string) => {
    onWorkshopIdsChange(toggleIdInList(workshopIds, id));
  };
  return { toggleMerchant, toggleWorkshop };
}
